<!-- @format -->
<template>
  <input type="file" class="file-img" :id="'imgfile'" ref="uploadfile" @change="onFileChange" />
  <div :class="errormsg == '' ? '' : 'warn'">{{ errormsg }}</div>

  <div v-if="!emptyFile">
    <img :src="imagePath + imageName" :id="'preview-img'" class="preview-img" alt="Select Image!"
      v-show="isImageFile == true" @click="selectFile()" />

    <div class="file-upldbox" @click="selectFile()" v-if="isImageFile == false">
      <div class="upldborder">
        <img src="../assets/pdf.png" class="box-img" v-if="this.extension == '.pdf'" />
        <img src="../assets/doc.png" class="box-img" v-if="this.extension == '.doc' || this.extension == '.docx'" />
        <img src="../assets/xls.png" class="box-img" v-if="this.extension == '.xls' || this.extension == '.xlsx'" />
        <span class="file-name">{{ fileName }}</span>
      </div>
    </div>
  </div>

  <div class="upldbox" v-else>
    <div class="upldborder" @click="selectFile()">
      <div>
        <i class="fa fa-download fadwld" aria-hidden="true"></i>
      </div>
      <div class="chsfile">Choose a File</div>
    </div>
  </div>

</template>
<script>
// import axios from "axios";
import MyFun from "@/js/MyFun.js";

export default {
  emits: ["file-select"],
  props: ["imageName", "imagePath"],
  data() {
    return {
      loading: false,
      emptyFile: true,
      errormsg: "",
      extension: "",
      fileName: "",
      vaildextension: false,
      extlist: [
        ".jpg",
        ".jpeg",
        ".png",
        ".pdf",
        ".doc",
        ".docx",
        ".xls",
        ".xlsx",
      ],
    };
  },
  methods: {
    selectFile() {
      this.clearImage();
      var elem = document.querySelector("#imgfile");
      elem.click();
    },
    onFileChange(event) {
      this.selectedfile = event.target.files[0];
      this.errormsg = "";
      this.showPreview(event);
    },
    showPreview(event) {
      if (event.target.files.length > 0) {
        this.getExtension(event.target.files[0]);
        // console.log(this.extension);
        if (!MyFun.inList(this.extension, this.extlist)) {
          this.errormsg = "Please Select a Valid File!";
          this.vaildextension = false;
        } else {
          this.vaildextension = true;
          this.errormsg = "";
          this.emptyFile = false;
          var reader = new FileReader();
          reader.onload = function () {
            var output = document.getElementById("preview-img");
            output.src = reader.result;
          };
          reader.readAsDataURL(event.target.files[0]);
          var selfile = event.target.files[0];
          this.$emit("file-select", selfile);
        }
      }
    },
    getExtension(xobj) {
      var filename = xobj.name;
      this.fileName = filename;
      var exidx = filename.lastIndexOf(".");
      var ext = filename.substr(exidx);
      this.extension = ext;
    },
    checkExtension() {
      console.log(this.imageName);
      if (this.imageName != undefined) {
        if (
          (this.imageName != null ||
            this.imageName != "" ||
            this.imageName != undefined) &&
          (this.fileName == "" || this.fileName == undefined)
        ) {

          this.extension = this.imageName.substring(
            this.imageName.lastIndexOf("."),
            this.imageName.length
          );
          var imgfile = document.getElementById("imgfile");
          imgfile.value = "";
          this.fileName = this.imageName;
        }
      }
    },
    clearImage() {
      var preview = document.getElementById("preview-img");
      if (preview != null) preview.src = "";
      var imgfile = document.getElementById("imgfile");
      imgfile.value = "";
      this.fileName = "";
      this.emptyFile = true;
    },
  },
  computed: {
    isImageFile() {
      var isImg = "";
      isImg = MyFun.inList(this.extension, [".jpg", ".jpeg", ".png"]);
      console.log(this.extension);
      console.log(isImg);
      return isImg;
    },
  },
  updated() {
    this.checkExtension();
  },
};
</script>

<style scoped>
.upldbox {
  margin: 5px;
  height: 100px;
  width: 200px;
  border-radius: 5px;
  background-color: rgb(238 238 238);
  padding: 4px;
}

.upldborder {
  border: 2px dotted lightgrey;
  border-radius: 5px;
  background-color: rgb(238 238 238);
  min-height: 90px;
  max-height: fit-content;
}

.file-upldbox {
  position: relative;
  margin: 5px;
  height: 100px;
  width: fit-content;
  border-radius: 5px;
  background-color: rgb(238 238 238);
  padding: 4px;
}

.box-img {
  height: 70px;
}

.file-name {
  font-size: 12px;
  padding: 5px;
}

.warn {
  position: relative;
  width: calc(100%);
  padding: 0px;
  border-radius: 0px;
  color: red;
  font-size: 12px;
  text-align: center;
}

.fadwld {
  color: lightgrey;
  font-size: 22px;
  padding-top: 25px;
  display: block;
  text-align: center;
}

.chsfile {
  color: black;
  font-size: 14px;
  display: block;
  text-align: center;
}

.file-img {
  display: none;
}

.preview-img {
  max-width: 200px;
  height: 150px;
  margin: 10px;
  width: auto;
  cursor: pointer;
}
</style>
